import navigateTo from './navigateTo';

const redirectToLoginIfUnauthorized = (response: Response) => {
  if (response.status === 401) {
    const currentPath = window.location.pathname;
    navigateTo(`/login?origin=${currentPath}`);
  }
};

export default redirectToLoginIfUnauthorized;
